import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { AfterschoolComposeComponent } from './afterschool-compose.component';
import { take } from 'rxjs/operators';
import { Option } from '../../../../../../../classes';

@Injectable({
  providedIn: 'root'
})
export class AfterschoolComposeService {

  constructor(
    private modalService:BsModalService,
  ) { }
  open (option:Option) {
    const modal:BsModalRef = this.modalService.show(AfterschoolComposeComponent, {class:'modal-lg', initialState:{option}})
    return modal.content.action.pipe(take(1));

  }
}
